import styled from 'styled-components';

import { setBirthdaySet } from '../../../../domains/Auth/slice';
import { Container } from '../../../../GlobalComponents/Container';
import { ErrorMessage } from '../../../../GlobalComponents/ErrorMessage';
import { Flex } from '../../../../GlobalComponents/Flex';
import { SuccessMessage } from '../../../../GlobalComponents/SuccessMessage';
import { Title } from '../../../../GlobalComponents/Title';
import { useAppDispatch, useAppSelector } from '../../../../reduxstore/hooks';
import { useRemoveRewardMutation } from '../../../api';
import { setProfile } from '../../../state/profileSlice';
import RewardCard from '../components/RewardCard';

export type RewardDetails = {
	id: number;
	active: boolean;
	creation_date: string;
	reward_code?: number;
	reward: {
		id: number;
		name: string;
		description: string;
		start_date?: string;
		expire_date?: string;
		time_limit?: number;
		valid_everywhere?: boolean;
		LastModified: string;
		discount?: number;
	};
};

const RewardsDashboard = ({ rewards }: { rewards: RewardDetails[] }): JSX.Element => {
	const userId = useAppSelector(state => state.authReducer.id);

	const [removeReward, { isSuccess, error }] = useRemoveRewardMutation();
	const dispatch = useAppDispatch();

	const handleRemoveReward = async (rewardId: string) => {
		const payload = {
			id: userId,
			claimed_reward_id: rewardId
		};
		removeReward(payload)
			.unwrap()
			.then((res: ProfileResponse) => {
				dispatch(setProfile(res.data.profile));
				dispatch(setBirthdaySet(res.data.birthday_set));
			});
	};

	return (
		<Container>
			<Title>My Rewards</Title>
			{error && (
				<ErrorMessage
					message={
						'Could not complete this task. Please try again later.'
					}
				/>
			)}
			{isSuccess && <SuccessMessage message={'Changes saved!'} />}
			<Flex $flexDirection="column">
				{rewards.map((el, i) => (
					<RewardCard
						reward={el}
						key={i}
						onClick={() => {
							handleRemoveReward(el.id as any as string);
						}}
					/>
				))}
				{rewards.length === 0 && (
					<NoRewards>You don't have any rewards yet.</NoRewards>
				)}
			</Flex>
		</Container>
	);
};

export default RewardsDashboard;

const NoRewards = styled.h2`
	font-size: 24px;
	line-height: 100%;
	margin: 0;
	margin-bottom: 24px;
	color: #575757;
`;
